export default {
	accountAdminApiUrl: process.env.REACT_APP_ACCOUNT_ADMIN_API_URL,
	inboxAdminApiUrl: process.env.REACT_APP_INBOX_ADMIN_API_URL,
	inboxWhatsappChannelApiUrl: process.env.REACT_APP_INBOX_WHATSAPP_CHANNEL_API_URL
}
